<form novalidate [formGroup]="form" (ngSubmit)="formValidated()">
  <div class="form-group">
    <input
      type="email" formControlName="text" class="form-control"
      (keyup.control.enter)="onValidKey()" (keyup.meta.enter)="onValidKey()" placeholder="jane_doe@example.com"
    >
  </div>

  <button type="submit" [disabled]="!form.valid" class="peertube-button primary-button">
    @if (interact()) {
      <span i18n>Remote interact</span>
    } @else {
      <span i18n>Remote subscribe</span>
    }
  </button>

  <my-help *ngIf="!interact() && showHelp()">
    <ng-container i18n>
      You can subscribe to the channel via any ActivityPub-capable fediverse instance (PeerTube, Mastodon or Pleroma for example).
    </ng-container>
  </my-help>

  <my-help *ngIf="showHelp() && interact()">
    <ng-container i18n>
      You can interact with this via any ActivityPub-capable fediverse instance (PeerTube, Mastodon or Pleroma for example).
    </ng-container>
  </my-help>
</form>
